import eight from '../assets/svg/projects/eight.svg'
import five from '../assets/svg/projects/five.svg'
import four from '../assets/svg/projects/four.svg'
import one from '../assets/svg/projects/one.svg'
import seven from '../assets/svg/projects/seven.svg'
import six from '../assets/svg/projects/six.svg'
import three from '../assets/svg/projects/three.svg'
import two from '../assets/svg/projects/two.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Moto-World',
        projectDesc: 'Moto Phone is a Manufacturer Website.This is a MERN Stack website. This is a Motor Bike Parts Selling web site.',
        tags: ['React', 'Tailwind', 'Firebase', 'Node js', 'Express.js', 'MongoDB', 'Heroku',],
        code: 'https://github.com/devSafayet/-manufacturer-website-client-side',
        demo: 'https://moto-world-4e151.web.app/',
        image: 'https://i.ibb.co/h28NfBF/moto-2.png'
    },
    {
        id: 2,
        projectName: 'Ohungry',
        projectDesc: 'This is a restaurant site. With this you can order the food of your choice online.',
        tags: ['React', 'React-Bootstrap', 'Sass', 'Firebase Auth', 'Fake-API',],
        code: 'https://github.com/devSafayet/Ohungry',
        demo: 'https://hungry-721f3.web.app//',
        image: 'https://i.ibb.co/2tsVDH7/Screenshot-3.png'
    },
    {
        id: 3,
        projectName: 'Apple Store',
        projectDesc: 'This is a Warehouse Management Website.There are routes for Only Admin.',
        tags: ['React', 'Bootstrap', 'Firebase', 'Node js', 'Express.js', 'MongoDB',],
        code: 'https://github.com/devSafayet/apple-store-client-side',
        demo: 'https://apple-store-abe66.web.app/',
        image: 'https://i.ibb.co/16s8KCq/apple-1.png'
    },
    {
        id: 4,
        projectName: 'Stooon Fashion',
        projectDesc: 'This project about travel agency management.',
        tags: ['React', 'Tailwind', 'Firebase', 'Fake API', 'DaisyUI'],
        code: 'https://github.com/devSafayet/stooon-fashion-shop-client-side',
        demo: 'https://stooon-fashion.web.app/',
        image: 'https://i.ibb.co/XWSCyyT/1.png'
    },
    {
        id: 5,
        projectName: 'Real-Estate Website demo',
        projectDesc: 'This is a real estate website. This is a front-end theme section added.',
        tags: ['React', 'Tailwind', 'Daisy UI', 'React icons'],
        code: 'https://github.com/devSafayet/real-estate-theme-frontend',
        demo: 'https://real-estate-theme.netlify.app/',
        image: 'https://i.ibb.co/LpRX0Cr/Screenshot-3.png'
    },
    {
        id: 6,
        projectName: 'Doctor Personal Website',
        projectDesc: 'Personal Doctor Website is a Independent Service Provider Website.Appointment has also implemented.',
        tags: ['React', 'Bootstap', 'Fake API', 'Firebase'],
        code: 'https://github.com/devSafayet/independent-service-provider-10',
        demo: 'https://independent-service-prov-b483b.web.app/',
        image: 'https://i.ibb.co/Ny9QS20/doctor-1-1.png'
    },
    {
        id: 7,
        projectName: 'Awesome Conventions Center',
        projectDesc: 'Awesome Convention Center.(This is Simple Design)',
        tags: ['HTML', 'CSS', 'Bootstap', 'Fontawesome'],
        code: 'https://github.com/devSafayet/awesome-convention-center',
        demo: 'https://awesome-conventions.netlify.app/',
        image: 'https://i.ibb.co/YDM3cwQ/Screenshot-1.png'
    },
    /* {
        id: 6,
        projectName: 'Uber Lite',
        projectDesc: 'Uber clone',
        tags: ['Flutter'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: one
    },
    {
        id: 7,
        projectName: 'Stock Market App',
        projectDesc: 'A simple stock market API app',
        tags: ['React', 'Redux', 'Bootstrap'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: two
    },
    {
        id: 8,
        projectName: 'Car Pooling System',
        projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
        tags: ['Flutter', 'React'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: three
    }, */
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/